import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-mark-charped",
  "use": "check-mark-charped-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"check-mark-charped\"><path d=\"M8.25 13.23a.75.75 0 01-.53-.22l-2-2A.75.75 0 016.78 10l1.43 1.44 3-3.4a.751.751 0 011.12 1l-3.5 4a.72.72 0 01-.53.25l-.05-.06z\" /><path d=\"M9 19.7a.75.75 0 01-.38-.1L.87 15.12a.74.74 0 01-.37-.65V5.53a.74.74 0 01.37-.65L8.62.4a.77.77 0 01.75 0l7.75 4.48a.73.73 0 01.38.65v8.94a.73.73 0 01-.38.65L9.37 19.6a.69.69 0 01-.37.1zM2 14l7 4 7-4V6L9 2 2 6v8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol